







import { createComponent, computed } from "@vue/composition-api";
import { getResourceModule } from "@/apps/apps";
import { SearchResult } from "@megarax/client/src/resources/search/SearchResult";

interface Props {
  value: SearchResult;
}

export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true },
  },
  setup(props, ctx) {
    const module = computed(() =>
      getResourceModule(props.value.app, props.value.resource),
    );

    const iconClass = computed(() => {
      if (!module.value) return undefined;
      return module.value.iconClass;
    });

    return { module, iconClass };
  },
});
